// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import glasses02Icon from "@/assets/icons/glasses-02.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Glasses02IconProps = Omit<IconProps, "name">;

export function Glasses02Icon(props: Glasses02IconProps): React.ReactNode {
  return <Icon name={glasses02Icon} {...props} />;
}
